import usePager from "../../../hooks/usePager";
import {useEffect} from "react";


export default function PagingDashboard( { totalItems }) {

    const {
        currentPage, setCurrentPage,
        itemsPerPage, setItemsPerPage,
        totalPages, setTotalPages,
    } = usePager();

    const handlePagingChange = (e) => {
        const itemPerPage = parseInt(e.target.value)
        setItemsPerPage(itemPerPage)
        setCurrentPage(1)
    };

    const handleFirstPageClick = () => {
        setCurrentPage(1)
    };

    const handlePreviousPageClick = () => {
        if (currentPage > 1) {
            setCurrentPage(currentPage-1)
        } else {
            setCurrentPage(1)
        }
    };

    useEffect(() => {
        if (!totalPages) {
            setTotalPages(1)
            setCurrentPage(1)
        }
    }, [ totalPages ]);

    const handleNextPageClick = () => {
        if (currentPage < totalPages) {
            setCurrentPage(currentPage + 1)
        } else {
            setCurrentPage(totalPages)
        }
    };

    const handleLastPageClick = () => {
        setCurrentPage(totalPages)
    };

    const handlePageNumber = (e) => {
        if (parseInt(e.target.value) <= parseInt(totalPages) && parseInt(e.target.value) >= 1) {
            setCurrentPage(parseInt(e.currentTarget.value))
        } else {
            setCurrentPage(totalPages)
        }
    };

    return (
        <div className="paging">
            <div className="left-paging-item">
                <label htmlFor="selectPaging">Affichage par page</label>
                <select name="selectPaging" onChange={handlePagingChange} value={ itemsPerPage }>
                    <option value={10}>10</option>
                    <option value={20}>20</option>
                    <option value={50}>50</option>
                    <option value={100}>100</option>
                    <option value={250}>250</option>
                    <option value={1000}>1000</option>
                </select>
            </div>
            <div className="center-paging-item">
                <span>{totalItems > 10 && `Résultats : ${totalItems}`}</span>
            </div>
            <div className="right-paging-item">
                <i className="fa fa-fast-backward" onClick={ handleFirstPageClick } />
                <i className="fa fa-play reverse" onClick={ handlePreviousPageClick } />
                <input
                    type="number"
                    name="current-page"
                    value={ currentPage }
                    onChange={ handlePageNumber }
                />
                <span>Page : {currentPage} / {totalPages}</span>
                <i className="fa fa-play" onClick={ handleNextPageClick } />
                <i className="fa fa-fast-forward" onClick={ handleLastPageClick } />
            </div>
        </div>
    )
}